import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCallIncoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCallIncoming"><Path d="M19.5 9.5H14.5V4.5M20.5 3.5L14.7489 9.25112M9 3.5L10 8L8.25636 9.74177C9.55309 12.334 11.666 14.4469 14.2582 15.7436L16 14L20.5 15V20.5H20.2424C17.1852 20.5 14.3194 19.6806 11.8527 18.2494C9.32535 16.7831 7.21688 14.6747 5.75058 12.1473C4.31941 9.68055 3.5 6.81476 3.5 3.75758C3.5 3.67156 3.50065 3.5857 3.50194 3.5H9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCallIncoming;
